<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const defaultLayout = "default";

export default defineComponent({
  setup() {
    const { currentRoute } = useRouter();
    const store = useStore();

    const layout = computed(
      () => `${currentRoute.value.meta.layout || defaultLayout}-layout`
    );
    onMounted(() => {
      if (localStorage.getItem('access_token')) {
        store.dispatch('getUserProfile');
      }
    });

    return {
      layout,
    };
  },
});
</script>
